$(() => {
    $('#show-map').on('click', (e) => {
        e.preventDefault();
        const $gmapImg = $('#gmap_img');
        const isLoaded = $gmapImg.attr('data-loaded') === 'true';
        
        if (!isLoaded) {
            const { latitude, longitude } = GoogleMapsApi;
            let url = `/landing/getstaticmap/${latitude}/${longitude}`;
            const zoom = $gmapImg.attr('data-zoom');
            const width = $gmapImg.attr('width');
            const height = $gmapImg.attr('height');
            
            if (zoom && width && height) {
                url += `/${zoom}/${width}/${height}`;
            }
            
            $.ajax({
                url,
                dataType: "json"
            }).done((data) => {
                $gmapImg.attr({
                    src: data.link,
                    'data-loaded': 'true'
                });
                $('.gmap').slideToggle('fast');
            });
        } else {
            $('.gmap').slideToggle('fast');
        }
        
        return false;
    });
});